import { render, staticRenderFns } from "./SMSServiceTabLinks.vue?vue&type=template&id=75e85099"
import script from "./SMSServiceTabLinks.vue?vue&type=script&lang=js"
export * from "./SMSServiceTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports